import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import logo from '../assets/logo2.png';
import { Linkedin, Twitter, Github } from 'lucide-react';
import heroBg from "../assets/hero-bg2.jpeg";

const Footer = () => {
  return (
    <motion.footer
      className="relative text-primary-foreground pt-0 pb-8 overflow-hidden"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundAttachment: 'fixed',
          filter: 'blur(0px)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-900/30 via-neutral-900/50 to-neutral-900/70"></div>
      </div>

      <div className="absolute inset-0 z-1 pointer-events-none">
        <div className="absolute top-10 left-10 w-20 h-20 bg-brand/10 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 bg-aiApplications/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-brand/5 rounded-full blur-2xl animate-float" style={{ animationDelay: '4s' }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12 pt-16">

          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src={logo} alt="Amama Ventures Logo" className="h-9 w-9" />
              <span className="text-white font-semibold text-xl">Amama Ventures</span>
            </Link>
            <p className="text-sm text-primary-foreground/70 leading-relaxed max-w-xs">
              Backing ambitious founders building AI-native, infrastructure, and global operating platforms across Europe, the Middle East, and India.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://github.com/" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-white transition-colors">
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/team" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Team</Link></li>
              <li><Link to="/contact" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/insights" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Insights</Link></li>
              <li><Link to="/portfolio" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Portfolio</Link></li>
              <li><Link to="/focus" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Focus</Link></li>
              {/* --- ADDED: Amama Bypass Link --- */}
              <li><Link to="/platform#bypass" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Amama Bypass</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="text-sm text-primary-foreground/70 hover:text-white transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="text-primary-foreground/70 mb-4 md:mb-0">
            © 2025 Amama Ventures. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-primary-foreground/70 hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="text-primary-foreground/70 hover:text-white transition-colors">Terms</Link>
            <Link to="/cookie-policy" className="text-primary-foreground/70 hover:text-white transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;